import { render, staticRenderFns } from "./colaboradores-icon.vue?vue&type=template&id=25aec7e8&"
import script from "./colaboradores-icon.vue?vue&type=script&lang=js&"
export * from "./colaboradores-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports